class FormValidation extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.formGroups = this.querySelectorAll('.form-group');
    console.log('formGroups', this.formGroups);

    this.formGroups.forEach((formGroup) =>
      formGroup.addEventListener('input', this.handleInput.bind(formGroup, this))
    );
  }

  handleInput(formGroup, event) {
    const input = event.target;
    const error = formGroup.querySelector('.form-group__error');

    if (input.checkValidity()) error.setAttribute('aria-invalid', 'false');

    // on unfocus input field check if the input value is invalid, show the error
    input.addEventListener('change', () => (input.hasChanged = true));
    input.addEventListener('blur', () => {
      if (!input.hasChanged) return;
      input.hasChanged = false;
      // Do your stuff
      if (input.checkValidity()) error.setAttribute('aria-invalid', 'false');
      else error.setAttribute('aria-invalid', 'true');
    });
  }
}

customElements.define('form-validation', FormValidation);
